import { useTranslation } from "@l2r-front/l2r-i18n"
import { PropTypes } from "@l2r-front/l2r-proptypes"

import { I18N_NAMESPACE } from "../../constants/i18n"

import * as Styled from "./Partnership.styled"

export const Partnership = (props) => {
    const {
        className,
        logo,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    return <Styled.Container className={className}>
        <Styled.Label variant="Desktop & Mobile/Body/Label & Helper text">{t(I18N_NAMESPACE, "components.partnership.label")}</Styled.Label>
        <Styled.LogoWrapper>
            {logo}
        </Styled.LogoWrapper>
    </Styled.Container>
}

Partnership.propTypes = {
    className: PropTypes.string,
    logo: PropTypes.node.isRequired,
}